module.exports = __webpack_public_path__ + "img/27_bohle.93adaf94.jpeg";